
































import { Component, Vue } from 'vue-property-decorator';
import isMobile from '@/utils/isMobile';

@Component({
  name: 'survey-page-wrapper',
})
export default class SurveyPageWrapper extends Vue {
  private isMobile!: boolean;

  created() {
    this.isMobile = isMobile();
  }

  private get isFullscreenDropdown(): boolean {
    return this.$store.state.isFullscreenDropdown;
  }

  private mounted() {
    window.addEventListener('scroll', this.scrollEventHandler);
  }

  private beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEventHandler);
  }

  private scrollEventHandler() {
    if (!this.isMobile) return;
    const logoEl = document.getElementById('logoWrapper');
    if (!logoEl) return;
    const pageWrapper = document.getElementById('pageWrapper');
    const logoHeight = logoEl?.getClientRects()[0].height;
    pageWrapper?.style.setProperty(
      '--opacity',
      `${1 - window.scrollY / logoHeight}`
    );
    pageWrapper?.style.setProperty(
      '--translateY',
      `-${(window.scrollY / logoHeight) * 65}px`
    );
  }
}
